import {CartStartCheckoutFragment} from '@graphcommerce/magento-cart/components/CartStartCheckout/CartStartCheckout.gql'
import React from 'react'
import {SxProps, Theme} from '@mui/material'
import {iconChevronRight, IconSvg, LinkOrButton} from '@graphcommerce/next-ui'
import {Trans} from '@lingui/react'

export type CartStartCheckoutNextButtonProps = CartStartCheckoutFragment & {
  children?: React.ReactNode
  sx?: SxProps<Theme>
}

export default function CustomStartCheckoutNextButton(props: CartStartCheckoutNextButtonProps) {
  const {
    children,
    ...cart
  } = props

  const hasTotals = (cart.prices?.grand_total?.value ?? 0) > 0
  const hasErrors = cart.items?.some((item) => (item?.errors?.length ?? 0) > 0)
  const locale = 'pro'

  return (
    <LinkOrButton
      onClick={(e) => {
        window.location.href = `/${locale}/checkout`
        return false;
      }}
      button={{ variant: 'pill' }}
      disabled={!hasTotals || hasErrors}
      color='secondary'
      endIcon={<IconSvg src={iconChevronRight} />}
    >
      <Trans id='Next' />
    </LinkOrButton>
  )
}
